import { Claim } from "@rumble-it/common-lib/types/models/Claim.interface";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Card } from "@rumbledirect/ui";
import { message, notification, Space } from "antd";
import { requestCalculationByClaimId } from "../../../../lib/api/resources/claims";

export const ClaimDossierOverviewActionsCard = ({
  claim,
  isLoading,
  setActiveTab,
}: {
  claim: Claim | null | undefined;
  isLoading: boolean;
  setActiveTab: (tabKey: string) => void;
}) => {
  const queryClient = useQueryClient();

  if (
    claim?.status === "claim_verstuurd" ||
    claim?.status === "calculatie_expertise_aangevraagd" ||
    claim?.status === "calculatie_afgekeurd"
  )
    return null;

  const requestCalculationMutation = useMutation({
    mutationFn: (claimId: string) => requestCalculationByClaimId(claimId),
    onSuccess: () => {
      notification.success({
        message: "Calculatie aangevraagd",
        description:
          "Er is een ESA-20 bericht verzonden naar de hersteller. De hersteller kan nu een calculatie indienen.",
      });
      setTimeout(() => {
        queryClient.resetQueries();
      }, 2500);
    },
    onError: () => {
      message.error("Er is iets misgegaan bij het aanvragen van de calculatie");
    },
  });

  return (
    <Card loading={isLoading} className="w-full mb-5" title="Acties">
      {claim && (
        <Space direction="vertical" className="w-full">
          {claim?.status === "concept" && (
            <Button
              type="primary"
              size="large"
              className="w-full"
              loading={requestCalculationMutation.isPending}
              onClick={() => requestCalculationMutation.mutate(claim?.id)}
            >
              Calculatie aanvragen
            </Button>
          )}
          {claim?.status === "calculatie_ontvangen" && (
            <Button
              type="primary"
              size="large"
              className="w-full"
              onClick={() => setActiveTab("calculation")}
            >
              Bekijk calculaties
            </Button>
          )}
          {claim?.status === "calculatie_expertise_ontvangen" && (
            <Button
              type="primary"
              size="large"
              className="w-full"
              onClick={() => setActiveTab("calculation")}
            >
              Bekijk expertise
            </Button>
          )}
          {claim?.status === "calculatie_goedgekeurd" && (
            <Button
              type="primary"
              size="large"
              className="w-full"
              onClick={() => setActiveTab("claiminfo")}
            >
              Bekijk claimverwerking
            </Button>
          )}
        </Space>
      )}
    </Card>
  );
};
